const cfg = {
    chessandcard: {
        "PG": "Hall/ChessAndCard/qipai_00",
        "EG": "Hall/ChessAndCard/qipai_01",
        "YG": "Hall/ChessAndCard/qipai_02",
        "NW": "Hall/ChessAndCard/qipai_03",
        "FG": "Hall/ChessAndCard/qipai_04",
        "RMG": "Hall/ChessAndCard/qipai_05",
        "MT": "Hall/ChessAndCard/qipai_06",
        "LY": "Hall/ChessAndCard/qipai_07",
        "VG": "Hall/ChessAndCard/qipai_08",
        "JDB": "Hall/ChessAndCard/qipai_09",
        "MW": "Hall/ChessAndCard/qipai_10",
        "TH": "Hall/ChessAndCard/qipai_11",
        "HT": "Hall/ChessAndCard/qipai_13",
        "DG": "Hall/ChessAndCard/qipai_14",
        "CQ": "Hall/ChessAndCard/qipai_15",
        "BSP": "Hall/ChessAndCard/qipai_16",
        "DT": "Hall/ChessAndCard/qipai_17",
        "PP": "Hall/ChessAndCard/qipai_18",
    },

    fish: {
    },

    electronic: {
        "BG": "Hall/Electronic/dianzi_00",
        "TH": "Hall/Electronic/dianzi_01",
        "PT": "Hall/Electronic/dianzi_02",
        "MW": "Hall/Electronic/dianzi_03",
        "PP": "Hall/Electronic/dianzi_04",
        "PG": "Hall/Electronic/dianzi_05",
        "MG": "Hall/Electronic/dianzi_06",
        "FG": "Hall/Electronic/dianzi_07",
        "AG": "Hall/Electronic/dianzi_08",
        "SG": "Hall/Electronic/dianzi_09",
        "JDB": "Hall/Electronic/dianzi_10",
        "MT": "Hall/Electronic/dianzi_11",
        "CQ": "Hall/Electronic/dianzi_12",
        "xxxxxxxxxxxxxxxxx": "Hall/Electronic/dianzi_13",
        "HT": "Hall/Electronic/dianzi_14",
        "DG": "Hall/Electronic/dianzi_15",
        "BBIN": "Hall/Electronic/dianzi_16",
        "RMG": "Hall/Electronic/dianzi_17",
        "LY": "Hall/Electronic/dianzi_18",
        "BSP": "Hall/Electronic/dianzi_19",
        "yyyyyyyyyyyyyyyyy": "Hall/Electronic/dianzi_20",
        "DT": "Hall/Electronic/dianzi_21",
        "SEA":"Hall/Electronic/dianzi_22",
        "ICG":"Hall/Electronic/dianzi_23",
    },

    sports: {
        "XJ": "Hall/Sports/188",
        "RIBO": "Hall/Sports/189",
        "CR": "Hall/Sports/huangguan",
        "SBO": "Hall/Sports/liji",
        "SB": "Hall/Sports/shaba",
        "BTI": "Hall/Sports/bti",
        "SH": "Hall/Sports/sansheng",
        "SONE":"Hall/Sports/douji",//新加斗鸡
        "IMSB":"Hall/Sports/im",

    },

    lottery: {
    },

    esports: {
        "IM": "Hall/ESports/dianjing_00",
        "RG": "Hall/ESports/dianjing_01",
        "AVIA": "Hall/ESports/dianjing_02",
        "TF": "Hall/ESports/dianjing_03",
    },

    livevideo: {
        "BG": "Hall/LiveVideo/bg",
        "AG": "Hall/LiveVideo/ag",
        "BBIN": "Hall/LiveVideo/bb",
        "PT": "Hall/LiveVideo/pt",
        "EVO": "Hall/LiveVideo/evo",
        "OB": "Hall/LiveVideo/ob",
        "IG": "Hall/LiveVideo/ig",
        "DGZR": "Hall/LiveVideo/dg",
        "EBET": "Hall/LiveVideo/ebet",
        "PP": "Hall/LiveVideo/play",
        "AE": "Hall/LiveVideo/ae",
        "RIBOLV": "Hall/LiveVideo/xj",
    },
}

export default cfg